import { render, staticRenderFns } from "./DeliveryInstructionModal.vue?vue&type=template&id=74047ac3&scoped=true&lang=pug"
import script from "./DeliveryInstructionModal.vue?vue&type=script&lang=js"
export * from "./DeliveryInstructionModal.vue?vue&type=script&lang=js"
import style0 from "./DeliveryInstructionModal.vue?vue&type=style&index=0&id=74047ac3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74047ac3",
  null
  
)

export default component.exports